import SolutionDetail from './SolutionDetail';

export default SolutionDetail;
